var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card recipe",
      class: { suggested: _vm.planner_suggested },
      attrs: {
        "data-link": _vm.recipe.lc_link,
        "data-id": _vm.recipe.id,
        "data-index": _vm.index
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.recipeClick.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "image-wrapper" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.thinking,
                    expression: "thinking"
                  }
                ],
                staticClass: "spinner"
              },
              [_c("i", { staticClass: "fas fa-utensil-fork" })]
            )
          ]),
          _vm._v(" "),
          _vm.recipe.lc_recipe_post_card_image
            ? _c("img", {
                staticClass: "card-img-top nopin",
                attrs: {
                  src: _vm.recipe.lc_recipe_post_card_image,
                  alt: _vm.recipe.post_title
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.logged_in
        ? _c("FavouriteWidget", {
            attrs: { post: _vm.recipe },
            on: {
              "update:post": function($event) {
                _vm.recipe = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.logged_in && _vm.show_planner
        ? _c("PlannerWidget", {
            attrs: {
              logged_in: _vm.logged_in,
              mode: _vm.planner_mode,
              show_suggest: _vm.planner_show_suggest,
              post_id_prop: parseInt(_vm.recipe.ID),
              date: _vm.planner_date
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.planner_suggested
        ? _c("div", { staticClass: "suggested-label" }, [_vm._v("Suggested")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", {
          staticClass: "card-title",
          domProps: { innerHTML: _vm._s(_vm.recipe.post_title) }
        }),
        _vm._v(" "),
        _vm.show_info
          ? _c("div", { staticClass: "info" }, [
              _vm.recipe.lc_recipe_post_top_serves
                ? _c("div", [
                    _vm._v(
                      "Serves " + _vm._s(_vm.recipe.lc_recipe_post_top_serves)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.recipe.lc_recipe_post_top_cook_time
                ? _c("div", [
                    _vm._v(
                      "Cook " + _vm._s(_vm.recipe.lc_recipe_post_top_cook_time)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.recipe.lc_recipe_post_top_prep_time
                ? _c("div", [
                    _vm._v(
                      "Prep " + _vm._s(_vm.recipe.lc_recipe_post_top_prep_time)
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.recipe.lc_timestamp && _vm.single_video
          ? _c("div", { staticClass: "timestamp" }, [
              _vm._v("Timestamp: " + _vm._s(_vm.recipe.lc_timestamp))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.debug
          ? _c("div", { staticClass: "debug" }, [
              _c("table", [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Post id")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.recipe.ID))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Pregnancy friendly")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.recipe.lc_pregnancy_friendly.toString())
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.planner_date
                    ? _c("tr", [
                        _c("td", [_vm._v("Planner date")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(JSON.stringify(_vm.planner_date)))
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }